import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The redirect origin is derived from window.location.origin at request time.
export default function GoogleCallback() {
  const nav = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const code = params.get("code");
    const error = params.get("error");
    if (error) {
      toast.error(`Google connect cancelled: ${error}`);
      nav("/settings", { replace: true });
      return;
    }
    if (!code) {
      nav("/settings", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/google/exchange", {
          code,
          state: params.get("state"),
          redirect_origin: window.location.origin,
        });
        toast.success(`Google connected as ${data.email || "you"}`);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google connect failed");
      } finally {
        nav("/settings", { replace: true });
      }
    })();
  }, [params, nav]);

  return (
    <div data-testid="google-callback" className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      Connecting your Google account…
    </div>
  );
}
